<pp-common-confirm-dialog-content
  [title]="null"
  [subTitle]="description | translate"
  [cancelCaption]="
    'notifications.dialog.showNotifications.actions.cancel' | translate
  "
  [okCaption]="
    'notifications.dialog.showNotifications.actions.confirm' | translate
  "
  iconName="notifications"
  status="warn"
  (discard)="closeDialog()"
  (ok)="confirm()" />
